import React from 'react';
import i18next from 'i18next';

import type { ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import KpisView from './KpisView';

import buttons from './KpisButtons';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('sys_kpis'),
	routes: [
		{
			path: 'kpis/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'sys_kpis'),
			element: (
				<ViewPage
					key="kpis/view"
					module="sys_kpis"
					content={{ type: 'tabs', tabs: KpisView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
